import React from 'react';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyApiKeyManagement = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "async-jira-eoc-api-key-management", jiraSpaEntry: "async-jira-eoc-api-key-management" */ '@atlassian/jira-eoc-api-key-management'
		),
);

const AsyncApiKeyManagement = (): React.JSX.Element => (
	<LazyPage
		Page={LazyApiKeyManagement}
		pageId="async-jira-eoc-api-key-management"
		shouldShowSpinner={false}
	/>
);

export default AsyncApiKeyManagement;
